import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

/**
 * Basic input
 * @param {String} labelFor - Id of the input attached to the label
 * @param {String} text - Text of the label
 * @param {String} subText - Sub text of the label, precise label
 * @param {String} className - ClassName applied to wrapper
 */
const Label = ({ labelFor, text, subText, infoLabel, className, small, inlineSub, children }) => {
    const labelContainerClasses = classnames(className, {
        'label-container': true,
        'label-container--info': infoLabel,
    });

    const labelClasses = classnames({
        label: true,
        'label--small': small,
        'label--info': infoLabel,
        'margin-right-half': !!subText && inlineSub,
    });

    return (
        <div className={labelContainerClasses}>
            {infoLabel && <span className="icon-info_outline" />}
            <label className={labelClasses} htmlFor={labelFor ? String(labelFor) : null}>
                {text}
            </label>
            {subText && (
                <p
                    className={`sublabel ${infoLabel ? 'sublabel--info' : ''} ${
                        inlineSub ? 'inline-block' : ''
                    }`}
                >
                    {subText}
                </p>
            )}
            {children}
        </div>
    );
};

Label.displayName = 'Label';

Label.propTypes = {
    className: PropTypes.string,
    inlineSub: PropTypes.bool,
    infoLabel: PropTypes.bool,
    labelFor: PropTypes.string,
    subText: PropTypes.string,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    small: PropTypes.bool,
};

Label.defaultProps = {
    inlineSub: true,
};

/**
 * Label Functionnal Component
 */
export default Label;
